import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "image",
    style: _normalizeStyle({ background: 'url('+_ctx.item.media.img_url+') center center no-repeat', backgroundSize: 'cover' })
  }, null, 4))
}